/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_champ_pts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 points scored each race (25-18-15-12-10-8-6-4-2-1, +1 fastest lap bonus)`)
};

const es_f1_profile_tooltip_champ_pts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntos F1 por carrera (25-18-15-12-10-8-6-4-2-1, +1 bono vuelta rápida)`)
};

const de_f1_profile_tooltip_champ_pts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1-Punkte pro Rennen (25-18-15-12-10-8-6-4-2-1, +1 schnellste Runde Bonus)`)
};

const nl_f1_profile_tooltip_champ_pts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1-punten per race (25-18-15-12-10-8-6-4-2-1, +1 snelste ronde bonus)`)
};

const fr_f1_profile_tooltip_champ_pts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points F1 marqués par course (25-18-15-12-10-8-6-4-2-1, +1 bonus tour le plus rapide)`)
};

const it_f1_profile_tooltip_champ_pts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punti F1 ottenuti per gara (25-18-15-12-10-8-6-4-2-1, +1 bonus giro veloce)`)
};

const pt_br2_f1_profile_tooltip_champ_pts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontos F1 por corrida (25-18-15-12-10-8-6-4-2-1, +1 bônus volta mais rápida)`)
};

const pt_f1_profile_tooltip_champ_pts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontos F1 por corrida (25-18-15-12-10-8-6-4-2-1, +1 bónus volta mais rápida)`)
};

const ja_f1_profile_tooltip_champ_pts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各レースで獲得したF1ポイント (25-18-15-12-10-8-6-4-2-1, +1ファステストラップボーナス)`)
};

const zh_f1_profile_tooltip_champ_pts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每场比赛的F1积分（25-18-15-12-10-8-6-4-2-1，+1最快圈速奖励）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_champ_pts = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_champ_pts(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_champ_pts", locale)
	if (locale === "en") return en_f1_profile_tooltip_champ_pts(inputs)
	if (locale === "es") return es_f1_profile_tooltip_champ_pts(inputs)
	if (locale === "de") return de_f1_profile_tooltip_champ_pts(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_champ_pts(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_champ_pts(inputs)
	if (locale === "it") return it_f1_profile_tooltip_champ_pts(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_champ_pts(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_champ_pts(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_champ_pts(inputs)
	return zh_f1_profile_tooltip_champ_pts(inputs)
};